import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import {Observable, Subject} from 'rxjs';
import {CommunityMember} from '../../shared/CommunityMember';
import { shareReplay} from 'rxjs/operators';
import {CommunityConnectorService} from '../../shared/community-connector.service';
import {DesignInvitation} from '../../shared/DesignInvitation';
import {CardWebListElement} from '../../shared/CardWebListElement';
import {CardWebRestService} from '../../shared/card-web-rest.service';
import {Router} from '@angular/router';

@Component({
  selector: 'em-invitation-dialog',
  templateUrl: './invitation-dialog.component.html',
  styleUrl: './invitation-dialog.component.css'
})
export class InvitationDialogComponent {

  timestamp: string = undefined;
  ownCommunityMemberList$: Observable<CommunityMember[]>;
  private CACHE_SIZE = 1;
  designInvitation: DesignInvitation;
  cardDeckId: number;
  loadingError$: Subject<boolean>;
  sharedDesign: CardWebListElement;
  senderCommunityMember: CommunityMember;

  constructor(private ccs: CommunityConnectorService,
              private cws: CardWebRestService,
              private router: Router,
              @Inject(MAT_DIALOG_DATA) public data: { timestamp: string, cardDeckId: number}){
    this.timestamp = data.timestamp;
    this.cardDeckId = data.cardDeckId;
    this.loadingError$ = new Subject<boolean>();
  }

  ngOnInit(): void {
    this.ownCommunityMemberList$ = this.ccs.checkUserByMail().pipe(
        shareReplay(this.CACHE_SIZE)
    );

    // Retrieve designInvitation by invitationId
    this.ownCommunityMemberList$.subscribe(ownCommunityMemberList => {
      if (ownCommunityMemberList.length > 0) {
        const receiverId = ownCommunityMemberList[0].id;
        this.ccs.getDesignInvitation(this.timestamp, receiverId).subscribe(designInvitation => {
          this.designInvitation = designInvitation;
          if (this.designInvitation !== null && this.designInvitation.timestamp !== null) {
              this.getSharedDesign(designInvitation).subscribe( sharedDesign => {
                  this.sharedDesign = sharedDesign;
              });
              this.getAvatarByUserId(this.designInvitation.senderId).subscribe( communityMember => {
                this.senderCommunityMember = communityMember;
              });
          }
        });
      }
    });
  }

  getSharedDesign(designInvitation: DesignInvitation): Observable<CardWebListElement> {
    return this.cws.getDesignByDesignName(designInvitation.designName, designInvitation.senderAppId);
  }

  decodeDesignName(name: string) {
    return decodeURIComponent(name);
  }

  acceptDesignInvitation(ownCommunityMember: CommunityMember) {
    this.ccs.acceptDesignInvitation(this.designInvitation).subscribe( result => {
      this.cws.emitDesignInvitationChangeEvent();
      this.router.navigate(['/home']);
    });

  }

  getCommunityMemberUrl(username: string) {
    return this.ccs.getCommunityMemberUrl(username);
  }

  getCommunityMessageUrl(postUrl: string) {
    return this.ccs.getCommunityMessageUrl(postUrl);
  }

  declineDesignInvitation(ownCommunityMember: CommunityMember) {
    this.ccs.deleteDesignInvitation(this.designInvitation).subscribe();
    this.router.navigate(['/home']);
  }

  getAvatarTemplateUrl(avatarTemplate: string) {
    return this.ccs.getAvatarTemplateUrl(avatarTemplate);
  }

  private getAvatarByUserId(userId: number) {
    return this.ccs.getAvatarByUserId(userId);
  }

  routeViaDesignInvitation() {
    this.router.navigate(['/editor', this.cardDeckId, this.sharedDesign.name, this.designInvitation.timestamp]);
  }
}
